import { RowIndentComponent } from './components/row-indent.component';
import { RowExpandIconComponent } from './components/row-expand-icon.component';
import { NzSpinModule } from 'ng-zorro-antd';
import { DraggbleDirective } from './directives/draggble.directive';
import { NgModule } from '@angular/core';
import { DataTableComponent } from './components/data-table.component';
import { DataThDirective } from './directives/data-th.directive';
import { DataTdDirective } from './directives/data-td.directive';
import { DataTheadDirective } from './directives/data-thead.directive';
import { DataTbodyDirective } from './directives/data-tbody.directive';
import { DataTbodyTrDirective } from './directives/data-tbody-tr.directive';
import { DataDividerDirective } from './directives/data-divider.directive';
import { DataTableSortComponent } from './components/data-table-sort.component';

import { PaginationModule } from '../pagination/pagination.module';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    NzSpinModule
  ],
  declarations: [
    DataTableComponent,
    DataThDirective,
    DataTdDirective,
    DataTheadDirective,
    DataTbodyDirective,
    DataTbodyTrDirective,
    DataDividerDirective,
    DraggbleDirective,
    DataTableSortComponent,
    RowExpandIconComponent,
    RowIndentComponent
  ],
  exports: [
    DataTableComponent,
    DataTableSortComponent,
    DataThDirective,
    DataTdDirective,
    DataTheadDirective,
    DataTbodyDirective,
    DataTbodyTrDirective,
    DataDividerDirective,
    DraggbleDirective,
    DataTableSortComponent,
    RowExpandIconComponent,
    RowIndentComponent
  ]
})

export class TableModule {
}

